import React from "react";

import { Carousel } from "shared/components/Carousel";

import AnnouncementHero from "./AnnouncementHero";

const AnnouncementsCarousel = ({
  announcements = [],
  useGradient = false,
  gradientVariant = "blue"
}) => {
  if (!Array.isArray(announcements) || announcements.length === 0) {
    return null;
  }

  return (
    <Carousel
      items={announcements}
      getKey={(announcement) => announcement.id}
      ariaLabel="Ogłoszenia"
      controlsAlignment="center"
      renderItem={(announcement, index, controls) => (
        <AnnouncementHero
          announcement={announcement}
          carouselControls={controls}
          useGradient={useGradient}
          gradientVariant={gradientVariant}
        />
      )}
    />
  );
};

export default AnnouncementsCarousel;